module.exports = __webpack_public_path__ + "static/media/yellow-triangle-filled.4d053aa6.png";